"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
const index_1 = require("../Base/index");
/**
 * Describes a global BPMN error element.
 * Can be thrown by an ErrorEndEvent and caught by an ErrorBoundaryEvent.
 */
class Error extends index_1.BaseElement {
}
exports.Error = Error;
//# sourceMappingURL=Error.js.map